import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/propertyStaff/selectList',
    method: 'get',
    params: data,
  });
}

export function save(data) {
  return request({
    url: '/propertyStaff',
    method: 'post',
    data: data,
  });
}

export function detail(data) {
  return request({
    url: '/propertyStaff',
    method: 'get',
    params: data,
  });
}

export function remove(param) {
  return request({
    url: '/propertyStaff/' + param,
    method: 'delete',
  });
}

// 批量保存
export function NbBatchAdd(data) {
  return request({
    url: '/propertyStaff/batchAdd',
    method: 'post',
    data: data,
  });
}

// 获取路径
export function getPath(data) {
  return request({
    url: '/basicExcelTemplate/getPath',
    method: 'get',
    params: data,
  });
}

// 模板下载
export function load(data) {
  return request({
    url: '/file/load',
    method: 'get',
    params: data,
    responseType: 'arraybuffer',
  });
}

// 人员区域信息列表查询
export function staffDistrictSelectList(data) {
  return request({
    url: '/staffDistrict/selectList',
    method: 'get',
    params: data,
  });
}

// 区域保存
export function staffDistrictAdd(data) {
  return request({
    url: '/staffDistrict',
    method: 'post',
    data: data,
  });
}

// 人员区域信息删除
export function staffDistrictDelete(data) {
  return request({
    url: '/staffDistrict/delete',
    method: 'get',
    params: data,
  });
}